import {NgModule} from '@angular/core';
import {FullScreenButtonDirective} from '@shared/directives/full-screen-button.directive';
import {MatPopoverDirective} from '@shared/directives/mat-popover.directive';
import {LeafletComponent} from '@shared/leaflet/leaflet.component';
import {MatDialogHoverComponent} from '@shared/mat-dialog-hover/mat-dialog-hover.component';
import {ShapeComponent} from '@shared/shape/shape.component';

import {CommonModule} from '@angular/common';
import {GoogleMapsModule} from '@angular/google-maps';
import {TranslateModule} from '@ngx-translate/core';
import {AlertErrorComponent} from '@shared/alert/alert-error.component';
import {AlertNotifierComponent} from '@shared/alert/alert-notifier.component';
import {AlertComponent} from '@shared/alert/alert.component';
import {ConfirmDialogComponent} from '@shared/confirm-dialog/confirm-dialog.component';
import {DialogService} from '@shared/confirm-dialog/dialog.service';
import {DataTableComponent} from '@shared/data-table/data-table.component';
import {GridComponent} from '@shared/grid/grid.component';
import {ListImagesComponent} from '@shared/list-images/list-images.component';
import {LoadingScreenComponent} from '@shared/loading-screen/loading-screen.component';
import {MapComponent} from '@shared/map/map.component';
import {MenuListItemComponent} from '@shared/menu-list-item/menu-list-item.component';
import {DateFormatPipe} from '@shared/pipes/date-format.pipe';
import {PadNumberPipe} from '@shared/pipes/pad-number.pipe';
import {SharedLibsModule} from '@shared/shared-libs.module';

@NgModule({
  imports: [CommonModule, SharedLibsModule, GoogleMapsModule, TranslateModule],
  declarations: [
    AlertComponent,
    AlertErrorComponent,
    AlertNotifierComponent,
    GridComponent,
    ConfirmDialogComponent,
    LoadingScreenComponent,
    DateFormatPipe,
    PadNumberPipe,
    MenuListItemComponent,
    DataTableComponent,
    ListImagesComponent,
    ShapeComponent,
    FullScreenButtonDirective,
    MatDialogHoverComponent,
    MatPopoverDirective,
    LeafletComponent,
    MapComponent,
  ],
  providers: [DialogService],
  exports: [
    SharedLibsModule,
    AlertComponent,
    AlertErrorComponent,
    AlertNotifierComponent,
    GridComponent,
    ConfirmDialogComponent,
    LoadingScreenComponent,
    DateFormatPipe,
    PadNumberPipe,
    MenuListItemComponent,
    DataTableComponent,
    ListImagesComponent,
    ShapeComponent,
    FullScreenButtonDirective,
    MatPopoverDirective,
    MatDialogHoverComponent,
    LeafletComponent,
    MapComponent,
    GoogleMapsModule,
    TranslateModule,
  ],
  entryComponents: [ConfirmDialogComponent, MatDialogHoverComponent],
})
export class SharedCommonModule {}
